import RightsPolicyPage from "pages/legal/RightsPolicyPage";
import React from "react";

const RightsPolicyRoute = () => <RightsPolicyPage />;

export default RightsPolicyRoute;
